import { ApiType } from "@gymflow/common";
import { PublicCreditPackApiType } from "@gymflow/common/lib/api/publicCreditPackApi";
import { useQuery } from "@tanstack/react-query";

import { creditPackAsPublicQueryKeys } from "./creditPackAsPublicQueryKeys";

export function useQueryCreditPackAsPublic({
  api,
  creditPackId,
}: {
  api: ApiType;
  creditPackId?: Parameters<PublicCreditPackApiType["getById"]>[0];
}) {
  return useQuery({
    queryKey: creditPackAsPublicQueryKeys.details(creditPackId),
    queryFn: async () => {
      return (await api.public.creditPackApi.getById(creditPackId!)).data;
    },
    enabled: !!creditPackId,
  });
}
